module.exports = __webpack_public_path__ + "img/t-search.87ce1a19.png";